import { render, staticRenderFns } from "./PageAppOverview.vue?vue&type=template&id=2bdc764a&"
import script from "./PageAppOverview.vue?vue&type=script&lang=js&"
export * from "./PageAppOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports